import { render } from "./ArchiveCard.vue?vue&type=template&id=469e0e7d&scoped=true&ts=true"
import script from "./ArchiveCard.vue?vue&type=script&lang=ts"
export * from "./ArchiveCard.vue?vue&type=script&lang=ts"

import "./ArchiveCard.vue?vue&type=style&index=0&id=469e0e7d&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469e0e7d"]])

export default __exports__